// common
import React from 'react';
// icon
import cn from 'classnames';
import Icon from './SCBIcon';
// packages
// styles
import css from './Preloader.module.scss';

class Preloader extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            isAppeared: false,
        };
    }

    componentDidMount() {
        this.setState({ isLoaded: true }, () => {
            setTimeout(() => {
                this.setState({ isAppeared: true });
            }, 700);
        });
    }

    render() {
        const {
            isLoaded,
            isAppeared,
        } = this.state;
        return (
            <div className={cn(css.wrapper, { [css.wrapper_embedded]: this.props.embedded })}>
                <Icon className={cn(css.logo, isLoaded && !isAppeared && css.appear, isAppeared && css.pulse)} />
            </div>
        );
    }
}

export default Preloader;
